var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityDementiaFriendly = function SvgAccessibilityDementiaFriendly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.557 14.96c.92.832 1.768 1.84 2.618 3.01 2.966 4.078 3.957 8.417 2.213 9.68s-5.561-1.009-8.527-5.088a21 21 0 0 1-1.922-3.26 20.7 20.7 0 0 1-3.805-.773C4.292 17.117.857 14.295 1.46 12.224s5.023-2.603 9.86-1.192a20 20 0 0 1 3.651 1.457 19.5 19.5 0 0 1 3.708-1.457c4.841-1.411 9.255-.878 9.86 1.192s-2.831 4.892-7.673 6.303a20 20 0 0 1-3.558.708 20 20 0 0 1-1.971 3.323c-2.966 4.072-6.785 6.356-8.528 5.089-1.742-1.268-.75-5.603 2.214-9.681a20 20 0 0 1 2.465-2.816 19.8 19.8 0 0 1-.39-4.02c0-5.037 1.749-9.13 3.904-9.13 2.156 0 3.904 4.088 3.904 9.13a22.4 22.4 0 0 1-.35 3.83z"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 15,
    cy: 16.195,
    r: 1
  }))));
};
export default SvgAccessibilityDementiaFriendly;